import { ITreeInputs } from '../../../../../../tree/interfaces/data.interface';
import { FieldModel } from '../../../../../../../../../../core/services/actions/models/field.model';
import { IParsedDataResponse, IDataService } from '../../../../../../../../../../core/services/data/data-service.interface';

export abstract class AbstractConfig {
  public static getLabel(key: string): string {
    return key
      .split(/(?=[A-Z])/)
      .join(' ')
      .split('_')
      .map((str) => str[0].toUpperCase() + str.slice(1))
      .join(' ');
  }

  constructor(protected settings: IConfigSettings, protected dataService: IDataService) {}
  public abstract readonly field: FieldModel | FieldModel[];
  public gridFields: number[] = [];

  public get globalData(): IParsedDataResponse {
    return this.dataService.getData();
  }

  protected get label(): string {
    return AbstractConfig.getLabel(this.settings.label || this.settings.key);
  }
}

export interface IConfigSettings extends ITreeInputs {
  label?: string;
}
